/*
 * LOUPIOTE - Options payantes de la fiche produit.
 *
 * Ce fichier ne touche pas au panier. L'ajout est fait par product-form.js, qui
 * joint les lignes cochees au meme appel /cart/add que le produit principal.
 * Ici on ne fait que deux choses :
 *   1. reporter l'etat de la case a cocher dans le `.qty-input` que
 *      product-form.js viendra lire (1 cochee, 0 sinon) ;
 *   2. tenir le total affiche a jour, pour que la cliente voie ce qu'elle va
 *      payer avant de cliquer, et non apres.
 *
 * Le total est recalcule a partir du prix de la variante courante, jamais a
 * partir du montant deja affiche : additionner du texte deja formate derive au
 * bout de quelques bascules, et la moindre erreur d'arrondi se voit sur un
 * bouton de paiement.
 */
(function () {
  'use strict';

  var bloc = document.querySelector('[data-lp-options]');
  if (!bloc) return;

  /* Format monetaire du theme : « 299€ », et « 9,50€ » s'il y a des centimes.
     On reproduit `money_without_trailing_zeros` plutot que d'appeler un
     utilitaire global qui peut ne pas etre charge sur cette page. */
  function euros(cents) {
    var v = Math.round(cents) / 100;
    var s = v.toFixed(2).replace('.', ',');
    if (s.slice(-3) === ',00') s = s.slice(0, -3);
    return s + '€';
  }

  function prixBase() {
    var p = parseInt(bloc.getAttribute('data-lp-base-price'), 10);
    return isNaN(p) ? 0 : p;
  }

  /* Deux prix, et il ne faut pas les confondre.

     prixLigne  : ce qui COMPTE dans le total. Zero tant qu'aucun modele n'est
                  choisi, sinon le prix de la variante choisie.
     prixAffiche: ce qui se LIT sur la ligne. Au repos, le prix par defaut du
                  produit, sans quoi l'option annonce « +0 € » et a l'air gratuite. */
  function prixLigne(ligne) {
    var sel = ligne.querySelector('.lp-opt__select');
    if (sel) {
      var o = sel.options[sel.selectedIndex];
      return o ? parseInt(o.getAttribute('data-price'), 10) || 0 : 0;
    }
    var c = ligne.querySelector('.lp-opt__box');
    return c ? parseInt(c.getAttribute('data-lp-option-price'), 10) || 0 : 0;
  }

  function prixAffiche(ligne) {
    var p = prixLigne(ligne);
    if (p) return p;
    var sel = ligne.querySelector('.lp-opt__select');
    if (sel) return parseInt(sel.getAttribute('data-price-defaut'), 10) || 0;
    return 0;
  }

  function total() {
    var t = prixBase();
    bloc.querySelectorAll('.lp-opt').forEach(function (ligne) {
      var c = ligne.querySelector('.lp-opt__box');
      if (c && c.checked) t += prixLigne(ligne);
    });
    return t;
  }

  /* Une ligne a menu n'est cochable qu'une fois le modele choisi : sans cela le panier
     partirait avec une variante prise au hasard, et le client recevrait des pales qu'il
     n'a pas choisies. */
  function majChoix(ligne) {
    var sel = ligne.querySelector('.lp-opt__select');
    if (!sel) return;
    var c = ligne.querySelector('.lp-opt__box');
    var addon = ligne.querySelector('.addonProduct');
    var qty = ligne.querySelector('.qty-input');
    var o = sel.options[sel.selectedIndex];
    var vid = sel.value;

    if (addon) addon.value = vid;
    if (!vid && c && c.checked) {
      c.checked = false;
      if (qty) qty.value = 0;
      ligne.classList.remove('lp-opt--on');
    }
    if (c) c.disabled = !vid;
    ligne.classList.toggle('lp-opt--vide', !vid);

    var img = ligne.querySelector('.lp-opt__thumb');
    var src = o ? o.getAttribute('data-img') : '';
    if (img && src) img.setAttribute('src', src);

    var prix = ligne.querySelector('.lp-opt__price');
    if (prix) prix.textContent = '+' + euros(prixAffiche(ligne));
  }

  /* Les trois surfaces qui annoncent le meme montant. Si l'une d'elles diverge,
     la cliente decouvre un prix different au clic : c'est le pire moment. */
  function peindre() {
    var txt = euros(total());
    document.querySelectorAll('.total_final_price').forEach(function (el) { el.textContent = txt; });
    document.querySelectorAll('.btn_final_price').forEach(function (el) { el.textContent = txt; });
    document.querySelectorAll('.sticky-atc-price').forEach(function (el) { el.textContent = txt; });
  }

  bloc.addEventListener('change', function (evt) {
    var t = evt.target;

    if (t.classList && t.classList.contains('lp-opt__select')) {
      var l = t.closest('.lp-opt');
      if (l) {
        majChoix(l);
        /* Choisir un modele vaut acceptation : demander en plus de cocher, c'est
           faire valider deux fois la meme decision, et la case restee vide se lit
           comme une etape ratee. Le decochage reste evidemment possible.
           On ne coche que sur un geste REEL : ce bloc est dans le gestionnaire du
           menu, pas dans majChoix, qui tourne aussi au chargement et apres un
           ajout au panier. */
        var c = l.querySelector('.lp-opt__box');
        if (t.value && c && !c.checked && !c.disabled) {
          c.checked = true;
          var q = l.querySelector('.qty-input');
          if (q) q.value = 1;
          l.classList.add('lp-opt--on');
        }
        peindre();
      }
      return;
    }

    var c = t;
    if (!c.classList || !c.classList.contains('lp-opt__box')) return;

    var ligne = c.closest('.check_box');
    if (ligne) {
      var qty = ligne.querySelector('.qty-input');
      if (qty) {
        qty.value = c.checked ? 1 : 0;
        qty.dispatchEvent(new Event('change', { bubbles: true }));
      }
      ligne.classList.toggle('lp-opt--on', c.checked);
    }
    peindre();
  });

  /* Changement de variante : le theme reecrit le prix depuis le HTML serveur,
     donc sans les options. On repeint apres lui. */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
      var v = evt && evt.data && evt.data.variant;
      /* Accès privé Black Friday : le prix de la variante arrive brut, on le remise comme le serveur. */
      var pct = parseInt(bloc.getAttribute('data-lp-base-pct'), 10) || 0;
      if (v && typeof v.price === 'number') bloc.setAttribute('data-lp-base-price', Math.round(v.price * (100 - pct) / 100));
      setTimeout(peindre, 0);
    });
  }

  /* Un retour arriere du navigateur restitue les cases cochees mais pas les
     `.qty-input` : on resynchronise au chargement. */
  bloc.querySelectorAll('.lp-opt').forEach(function (ligne) {
    var c = ligne.querySelector('.lp-opt__box');
    var qty = ligne.querySelector('.qty-input');
    if (c && qty) qty.value = c.checked ? 1 : 0;
    if (c) ligne.classList.toggle('lp-opt--on', c.checked);
    majChoix(ligne);
  });
  peindre();

  /* Apres un ajout au panier reussi, les cases restent cochees alors que les
     lignes sont deja au panier : les recocher enverrait un doublon.

     On ecoute l'evenement `cartUpdate` du theme, et non le `submit` du
     formulaire : la page porte TROIS formulaires vers /cart/add, dont celui
     d'Alma en premier, et `querySelector` ramassait celui-la. L'evenement, lui,
     ne se declenche qu'apres un ajout reellement abouti. */
  function decocherTout() {
    bloc.querySelectorAll('.lp-opt__box').forEach(function (c) {
      if (!c.checked) return;
      c.checked = false;
      var ligne = c.closest('.check_box');
      if (!ligne) return;
      var qty = ligne.querySelector('.qty-input');
      if (qty) qty.value = 0;
      ligne.classList.remove('lp-opt--on');
      var sel = ligne.querySelector('.lp-opt__select');
      if (sel) { sel.selectedIndex = 0; majChoix(ligne); }
    });
    peindre();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
      /* Les deux evenements du theme n'ont pas la meme forme : `variantChange`
         emballe sa charge dans `.data`, `cartUpdate` la publie a plat. On lit
         donc les deux, plutot que de parier sur l'une des deux conventions. */
      var src = (evt && evt.source) || (evt && evt.data && evt.data.source);
      if (src === 'product-form') decocherTout();
    });
  }
})();
